import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { Website } from '../website-builder/wedding';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsStateStore } from '../settings/settings.state.store';
import { RegistryStateStore } from '../registry/registry.state.store';
import { Settings } from '../settings/settings';
import { Registry } from '../registry/registry';

import { default as defaultWebsiteCeline } from '../website-template-celine/default-data';
import { default as defaultWebsiteLottie } from '../website-template-lottie/default-data';
import { BaseWebsiteTemplate } from './template-base';
import { Gift } from '../gift/gift';
import { RegistryService } from '../registry/registry.service';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebsiteComponent implements OnInit {
  @ViewChildren('templateRef') templates: QueryList<BaseWebsiteTemplate>;
  @Input() cssClass = '';
  @Input() template: string;
  @Input() isInBuilder: boolean = false;
  @Input() website: Website;
  @Input() registry: Registry;
  @Input() gifts: Gift[];
  isInWebsiteBuilder = false;
  @Input() siteName: string;
  @Input() isPreview: boolean;
  @Input() groupedScheduleItems: any = [];
  @Input() useDefaultData: boolean;
  templateId: any;
  settings: Settings;
  // isPreview: boolean;
  originalWebsite: Website;
  isTempllatePreview = false;
  @Input() viewingTranslatedMode = false;
  dontShowPreviewPill: boolean;
  wrongPassword: boolean;
  password: string;
  passwordOk: boolean;
  showTranslation: boolean;

  constructor(
    private _state: WebsiteStateStore,
    private _settingsState: SettingsStateStore,
    private _registryState: RegistryStateStore,
    private route: ActivatedRoute,
    private router: Router,
    private registryService: RegistryService,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document
  ) { 

    this.isInWebsiteBuilder = location.pathname.toLowerCase().includes('/website/builder');
  }

  ngOnInit() {
    localStorage.removeItem('p2');
    this.templateId = this.route.snapshot.paramMap.get('templateId');  // Get templateId from the route

    if (this.template) {

      let defaultPreviewWebsite = this.getDefaultWebsiteTemplate(this.template)
      this.website = defaultPreviewWebsite;

    }



    if (!this.registry) {
      this._registryState.getState().subscribe(state => {

        this.registry = state.registry
        if (this.registry) {
          this.updateRegistryModal(this.registry);
        }
        this.setPageTitle();
        this.checkPreviousPW();
      });
    }
    this.setPageTitle();
    if (this.siteName && !this.website) {
      this._state.getWebsiteByName(this.siteName);
    }
    if (!this.templateId && this.template) {
      this.templateId = this.template;
    } else if (!this.templateId && this.website && this.website.template) {
      this.templateId = this.website.template;

    }
    this.isTempllatePreview = this.router.url.includes('preview-template')
    if (this.useDefaultData) {
      this.useDefaultData = this.isTempllatePreview
    }
    if (!this.isPreview) {
      this.isPreview = location.search.includes("preview");;
    }
    this.dontShowPreviewPill = false;
    if (location.pathname.endsWith('/builder')) {
      this.dontShowPreviewPill = true;
    }
    ;
    if (this.website && Object.keys(this.website).length > 0) {
      this._state.loadFonts(this.website, this.document);
      if(this.website.userId){
        
      this._settingsState.getSettingsViaUserId(this.website.userId).subscribe(settings => {
        this.settings = settings;
      
            if(!this.isInWebsiteBuilder && this.settings && this.settings.enableTranslations && this.settings.defaultLanguage!= "English"){
              this.showTranslation = true;
            } 
        
           
        if(this.cdr && !this.cdr['destroyed']){        
          this.cdr.detectChanges();      
       }
      });
    }
    } else {
      this._state.getState().subscribe(state => {
        if (!this.isTempllatePreview && !this.useDefaultData) {
          if (state && state.website) {
            this.website = state.website;
            this.templateId = state.website.template;
            this._state.loadFonts(this.website, this.document);
          }
          if (state && state.settings) {
            this.settings = state.settings;
            if(this.cdr && !this.cdr['destroyed']){        
              this.cdr.detectChanges();      
           }
          }
        }
        this.groupedScheduleItems = state.groupedScheduleItems;
      });
    }
    this._state.tranlsationEmitted$.subscribe(tranlation => {

      this.viewingTranslatedMode = tranlation;
    });




  }

  setPageTitle() {
    if (!this.isPreview && !this.isTempllatePreview && this.registry) {

      let title = this.registry.firstName + " and " + this.registry.partnerFirstName;

      title += ' — Hitchd'
      document.title = title;

    };
  }


  clearError() {
    this.wrongPassword = false;
  }

  getDefaultWebsiteTemplate(templateName: string) {
    switch (templateName) {
      case 'celine':
        return defaultWebsiteCeline;
      case 'lottie':
        return defaultWebsiteLottie;
      default:
        return defaultWebsiteCeline;
    }
  }
  reverseTranslation(website: Website) {
    this.website = website
    this.viewingTranslatedMode = false;
  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes.website) {
      // this.website = changes.website.currentValue;
      this.templateId = this.website.template;


    }
  }

  checkPreviousPW() {
    if (this.registry && this.registry.password) {
      let olPW = localStorage.getItem('p2');
      if (olPW === this.registry.password) {
        this.passwordOk = true;
      }
    }
  }


  changeLang() {

    this.templates.first.changeLang();
    this.showTranslation = !this.showTranslation;
    this._state.emitTranlation(this.showTranslation)
  }
  updateWebsiteModal(website: Website) {
    ;
    this.website = website;
    if (this.templates && this.templates.first) {
      this.templates.first.updateWebsiteModal(this.website)
      if (this.cdr && !this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }
    
  }

  updateRegistryModal(registry: Registry) {
    this.registry = registry;
    if (this.templates) {
      this.templates.first.updateRegistryModal(this.registry)
      if (this.cdr && !this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }
  }

  CheckPassword() {
    this.wrongPassword = false;
    localStorage.removeItem('p2');
    if (this.password === this.registry.password) {
      this.passwordOk = true;
      localStorage.setItem('p2', this.password);
    } else {
      this.wrongPassword = true;
    }
  }

  scrollToSection3() {
    document.getElementById('3').scrollIntoView({
      behavior: 'smooth'
    });
  }

  setWebsiteToLive() {
    if (!this.website.isLive) {
      // Set website to public
      this.website.isLive = true;

      // Update website state
      this._state.updateWebsite(this.website);

      // Show success message
      this.registryService.emitGenericToastMsg("Your site is now public");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/website/website.component.ts